import { render, staticRenderFns } from "./FullEmail.vue?vue&type=template&id=63fc40eb"
import script from "./FullEmail.vue?vue&type=script&lang=js"
export * from "./FullEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports